import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faArrowLeft,
  faMicrophone,
  faSearch,
  faTimes,
  faUtensils,
  faHome,
  faShower,
  faTshirt,
  faEllipsisH,
  faUser,
  faUsers,
  faChild,
  faMars,
  faVenus,
  faTransgender,
  faIdCard,
  faExclamationTriangle,
  faClock,
  faPhone,
  faCheck,
  faSlidersH,
  faTimesCircle,
  faCrosshairs,
  faCamera,
  faArrowsAlt,
  faPlus,
  faSpinner,
  faTrash,
  faBars,
} from '@fortawesome/free-solid-svg-icons';
import {
  faTwitterSquare,
  faFacebookSquare,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';

library.add(
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faArrowLeft,
  faMicrophone,
  faSearch,
  faTimes,
  faUtensils,
  faHome,
  faShower,
  faTshirt,
  faEllipsisH,
  faUser,
  faUsers,
  faChild,
  faMars,
  faVenus,
  faTransgender,
  faIdCard,
  faExclamationTriangle,
  faClock,
  faPhone,
  faCheck,
  faSlidersH,
  faTimesCircle,
  faCrosshairs,
  faCamera,
  faArrowsAlt,
  faPlus,
  faSpinner,
  faTrash,
  faTwitterSquare,
  faFacebookSquare,
  faLinkedin,
  faBars,
);
